// import React, { useEffect } from "react";
import "../Css/Navbar.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import { FcHome } from "react-icons/fc";
import { FcAbout } from "react-icons/fc";
import { FcBusinessContact } from "react-icons/fc";
// import { useAuth0 } from "@auth0/auth0-react";
import { NavLink } from "react-router-dom";
import { AiOutlineProject } from "react-icons/ai";
import { FcServices } from "react-icons/fc";
import NavDropdown from "react-bootstrap/NavDropdown";
import Wishes from "./wishes";
import { FcBusinessman } from "react-icons/fc";
// import { TiWeatherSunny } from "react-icons/ti";
import DayNightToggle from "react-day-and-night-toggle";
import { useState } from "react";
// import Dashpng from "../Components/image/Mlogo1.png";

function Navbar1() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const setDarkmode = () => {
    document.querySelector("body").setAttribute("data-theme", "dark");
    localStorage.setItem("selectedTheme", "dark");
  };
  const setlightmode = () => {
    document.querySelector("body").setAttribute("data-theme", "light");
    localStorage.setItem("selectedTheme", "light");
  };
  const selectedTheme = localStorage.getItem("selectedTheme");
  if (selectedTheme === "light") {
    setlightmode();
  }
  const toggleTheme = () => {
    if (isDarkMode === true) {
      setlightmode();
    } else {
      setDarkmode();
    }
  };

  // const { loginWithRedirect } = useAuth0();
  // const { user, isAuthenticated } = useAuth0();
  // const { logout } = useAuth0();
  return (
    <div>
      <Navbar id="mainnav" expand="lg" className="fixed-top">
        <Container fluid>
          <Navbar.Brand to="" className="m-2">
            <NavLink to="/" id="logo">
              Montu kharb
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" id="toggler-icon" />
          <Navbar.Collapse id="navbar-scroll">
            <Nav
              className="me-auto my-2 my-lg-0 p-2 m-5 sascroll"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <NavLink id="text" className="m-3" to="/">
                <i id="icon">
                  <FcHome />
                </i>{" "}
                Home
              </NavLink>
              <NavLink id="text" className="m-3" to="/About">
                {" "}
                <i id="icon">
                  <FcAbout />
                </i>{" "}
                About
              </NavLink>
              <NavLink id="text" className="m-3" to="/Contact">
                <i id="icon">
                  <FcBusinessContact />
                </i>{" "}
                Contact
              </NavLink>
              <NavDropdown
                title="Blog"
                className="m-2  ik"
                id="navbarScrollingDropdown"
              >
                <NavDropdown.Item>
                  <NavLink id="textlist" to="/MovieReview">
                    Movie Review
                  </NavLink>{" "}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <NavLink id="textlist" to="/Story">
                    Story
                  </NavLink>
                </NavDropdown.Item>

                <NavDropdown.Item>
                  <NavLink id="textlist" to="/Languageprogram">
                    Languageprogram
                  </NavLink>
                </NavDropdown.Item>
              </NavDropdown>
              <NavLink id="text" to="/Projects" className="m-3">
                {" "}
                <i id="icon" style={{ color: "red" }}>
                  <AiOutlineProject />
                </i>{" "}
                Project
              </NavLink>

              <NavLink id="text" to="/Partners" className="m-3">
                <i id="icon">
                  <FcServices />
                </i>{" "}
                Service
              </NavLink>
            </Nav>
            {<Wishes />}
            {/* { isAuthenticated ?
            // <p>{user.name}</p>
            :
            null 
            }              */}
            {/* {isAuthenticated ? ( */}
            <div>
              <div className="dropdown" style={{ float: "right" }}>
                <button className="dropbtn">
                  <i id="icon">
                    <FcBusinessman />
                  </i>
                  sign up
                </button>
              </div>
            </div>
            <DayNightToggle
              className="switch"
              onChange={() => setIsDarkMode(!isDarkMode)}
              onClick={toggleTheme}
              checked={isDarkMode}
            />
            <Form className="d-flex"></Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Navbar1;
